/**
 * Trailblazers (TRL) team names.
 *
 * Teams pick their name from a curated, predetermined list. Admins can extend
 * the list with custom names and disable core names on a per-game basis. The
 * per-game overrides are stored on the game row (`trl_team_name_config`).
 */
/**
 * Core, themed pool of Trailblazers team names (pirate / seafaring flavoured).
 * Admins may disable any of these per-game and add their own.
 */
export const TRL_CORE_TEAM_NAMES = [
    'Pitiful PlankWalkers',
    'Savage Scallywags',
    'Nightfall Navigators',
    'Crimson Cutlasses',
    'Starboard Scoundrels',
    'Riptide Rogues',
    'Vicious Voyagers',
    'Emerald Exiles',
    'Seasick Swashbucklers',
    'Cursed Corsairs',
    'Mediocre Mariners',
    'Booty Bandits',
    'Shipwrecked Sailors',
    'Drunken Deckhands',
    'Lucky Looters',
    'Crooked Captains',
    'Overboard Outlaws',
    'Plundering Pirates',
    'Midnight Mercenaries',
    'Rowdy Renegades',
    'Ruthless Raiders',
    'Silent Serpents',
    'Wayward Wanderers',
    'Majestic Merchants',
    'Ancient Armada',
    'Brazen Brotherhood',
    'Sunburnt Seafarers',
    'Brutal Brigands',
    'Expendable Explorers',
    'Frostfang Fleet',
    'Horizon Hunters',
    'Oblivious Outcasts',
    'Lawless Legion',
    'Soggy Sea Dogs',
    'Forgetful Fishermen',
    'One-Eyed Widows',
    'Greedy Gamblers',
    'Nervous Nomads',
    'Penniless Pickpockets',
    'Menacing Mutineers',
];
/**
 * Default (empty) team-name config: full core list available, no custom names.
 */
export const DEFAULT_TRL_TEAM_NAME_CONFIG = {
    disabledCoreNames: [],
    customNames: [],
};
/**
 * Resolve the list of team names available to pick from for a game:
 * (core − disabled) ∪ custom, de-duplicated, preserving order (core first).
 */
export function resolveAvailableTeamNames(config) {
    const disabled = new Set(config?.disabledCoreNames ?? []);
    const custom = config?.customNames ?? [];
    const result = [];
    const seen = new Set();
    for (const name of TRL_CORE_TEAM_NAMES) {
        if (disabled.has(name) || seen.has(name))
            continue;
        seen.add(name);
        result.push(name);
    }
    for (const name of custom) {
        if (seen.has(name))
            continue;
        seen.add(name);
        result.push(name);
    }
    return result;
}
